import { ErrorActionTypes } from './action-types';
import { clearAnyLoading } from '../loading-status/action-creators';
export const setError = (errorKey, error = {
  message: ''
}) => dispatch => {
  dispatch(clearAnyLoading());
  return dispatch({
    type: ErrorActionTypes.SetError,
    errorKey,
    error: {
      message: error.message
    }
  });
};
export const clearError = () => dispatch => {
  return dispatch({
    type: ErrorActionTypes.ClearError
  });
};